module.exports = __webpack_public_path__ + "static/media/galerija_2017 (33).dfaf670e.jpg";